import { Action } from 'redux';
import { IExtractTaskInfo } from '../../../ts/models/IExtractTaskInfo';
import { RunExtractRefreshNow } from '../AppActionTypes';
import { RefreshTaskType } from '../../../ts/ServerApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { IContentInfo } from '../../../ts/models/IContentInfo';

export interface RunExtractRefreshNowAction extends Action {
    tasks: IContentInfo[];
}

export function runExtractRefreshNow(tasks: IContentInfo[]): RunExtractRefreshNowAction {
  return {
    type: RunExtractRefreshNow,
    tasks
  };
}
